var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon Trailing"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9994 22C6.47769 22 2 17.5236 2 12.0006C2.00626 6.48019 6.48019 2.00626 11.9994 2C17.5223 2 22 6.47769 22 12.0006C22 17.5236 17.5223 22 11.9994 22ZM11.9994 3.6674C7.39776 3.6674 3.66614 7.39776 3.66614 12.0006C3.67115 16.601 7.40026 20.3288 11.9994 20.3339C16.6022 20.3339 20.3339 16.6035 20.3339 12.0006C20.3339 7.39776 16.6022 3.6674 11.9994 3.6674ZM15.9404 15.9417C16.3168 15.5653 16.3168 14.955 15.9404 14.5785L13.3626 12.0007L15.9405 9.42274C16.3169 9.04632 16.3169 8.43602 15.9405 8.0596C15.5641 7.68318 14.9538 7.68318 14.5774 8.0596L11.9994 10.6376L9.42034 8.05848C9.04392 7.68205 8.43362 7.68205 8.0572 8.05847C7.68078 8.4349 7.68078 9.0452 8.0572 9.42162L10.6363 12.0007L8.05731 14.5797C7.68089 14.9561 7.68089 15.5664 8.05731 15.9428C8.43373 16.3192 9.04403 16.3192 9.42045 15.9428L11.9994 13.3638L14.5773 15.9417C14.9537 16.3181 15.564 16.3181 15.9404 15.9417Z",
    fill: "#C70000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/Error.969401bb55133fbd905da2e85613423b.svg";
export { ForwardRef as ReactComponent };